import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import NewsletterPopup from '../NewsletterPopup';

const Layout = () => {
  const [showNewsletter, setShowNewsletter] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Show newsletter popup after 10 seconds if not shown before
    const hasSeenNewsletter = localStorage.getItem('newsletterSeen');
    if (!hasSeenNewsletter) {
      const timer = setTimeout(() => {
        setShowNewsletter(true);
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const handleCloseNewsletter = () => {
    setShowNewsletter(false);
    localStorage.setItem('newsletterSeen', 'true');
  };

  return (
    <div className="min-h-screen flex flex-col bg-primary-50">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      {showNewsletter && <NewsletterPopup onClose={handleCloseNewsletter} />}
    </div>
  );
};

export default Layout;
